import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import ThreeScene from "../components/ThreeScene";
import { BRAND, CITY, stats, WHATSAPP_URL } from "../lib/data";

export default function About() {
    const values = [
        { icon: "fa-gem", title: "الجودة أولاً", desc: "لا نقبل بأقل من التميز في كل تفصيلة" },
        { icon: "fa-handshake", title: "شفافية كاملة", desc: "عروض واضحة بلا رسوم مخفية أو مفاجآت" },
        { icon: "fa-clock", title: "احترام الوقت", desc: "التزام صارم بمواعيد التسليم" },
        { icon: "fa-shield-halved", title: "ضمان يمتد", desc: "ضمان يصل إلى 5 سنوات على العزل" },
    ];

    return (
        <main data-testid="about-page">
            <section className="relative min-h-[60vh] dark-marble-bg overflow-hidden grain">
                <div className="absolute inset-0 opacity-35">
                    <ThreeScene variant="side" />
                </div>
                <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-40 pb-20 text-center">
                    <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
                        <div className="eyebrow mb-4">من نحن</div>
                        <h1 className="hero-title text-white mb-4">
                            قصة <span className="gold-text">شغف</span> بالرخام
                        </h1>
                    </motion.div>
                </div>
            </section>

            <section className="marble-bg py-20 md:py-28">
                <div className="max-w-7xl mx-auto px-6 md:px-10">
                    <div className="grid lg:grid-cols-2 gap-14 items-center">
                        <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
                            <div className="eyebrow mb-4">حكايتنا</div>
                            <h2 className="section-title text-[#0a0a0a] mb-6">
                                أكثر من عمل، <span className="gold-text">هوية فنية</span>
                            </h2>
                            <div className="divider-gold mb-6" />
                            <p className="text-[#0a0a0a]/75 text-lg leading-relaxed mb-4">
                                منذ تأسيسها، تكرّس شركة <strong>{BRAND}</strong> نفسها لتقديم أرقى خدمات جلي وتلميع الرخام في {CITY} ومنطقة عسير. نجمع بين التقنية الأوروبية الحديثة وحرفية معلمين تراكمت خبراتهم على مدى عقد ونصف.
                            </p>
                            <p className="text-[#0a0a0a]/75 text-lg leading-relaxed mb-8">
                                نؤمن أن كل قطعة رخام تحكي قصة، ومهمتنا هي أن نعيد لها بريقها الأول بأناقة وحرص شديد على أدق التفاصيل.
                            </p>
                            <Link to="/contact" className="gold-btn" data-testid="about-cta">
                                تواصل معنا <i className="fa-solid fa-arrow-left mr-2" />
                            </Link>
                        </motion.div>

                        <motion.div initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="relative">
                            <div className="relative rounded-3xl overflow-hidden gold-ring aspect-[4/5]">
                                <img src="https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=1200&q=80" alt="فريقنا" className="w-full h-full object-cover" />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                            </div>
                            <div className="absolute -bottom-6 -right-6 glass rounded-2xl p-6 shadow-2xl hidden md:block">
                                <div className="gold-text font-display text-4xl">12+</div>
                                <div className="text-[#0a0a0a]/70 text-xs">سنة من الحرفية</div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </section>

            <section className="bg-[#0a0a0a] py-20 md:py-24 relative overflow-hidden">
                <div className="absolute inset-0 opacity-20">
                    <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 50% 50%, rgba(201,169,97,0.3), transparent 60%)" }} />
                </div>
                <div className="relative max-w-7xl mx-auto px-6 md:px-10">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                        {stats.map((s, i) => (
                            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="text-center">
                                <div className="gold-text font-display text-5xl md:text-6xl mb-2">{s.value}</div>
                                <div className="text-white/60 text-sm">{s.label}</div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="marble-bg py-20 md:py-28">
                <div className="max-w-7xl mx-auto px-6 md:px-10">
                    <div className="text-center mb-14">
                        <div className="eyebrow mb-4">قيمنا</div>
                        <h2 className="section-title text-[#0a0a0a]">ما يميّزنا</h2>
                        <div className="divider-gold mx-auto mt-4" />
                    </div>
                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {values.map((v, i) => (
                            <motion.div
                                key={i}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: i * 0.1 }}
                                className="glass rounded-2xl p-8 text-center tilt-hover"
                                data-testid={`value-${i}`}
                            >
                                <div className="w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-5" style={{ background: "linear-gradient(135deg, #e8c86a, #8a6d2b)" }}>
                                    <i className={`fa-solid ${v.icon} text-[#0a0a0a] text-xl`} />
                                </div>
                                <h3 className="font-display text-xl text-[#0a0a0a] mb-2">{v.title}</h3>
                                <p className="text-[#0a0a0a]/65 text-sm">{v.desc}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>
        </main>
    );
}
